var LazyLoad = function() {
    "use strict";
    const e = "undefined" != typeof window, t = e && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), a = e && window.devicePixelRatio > 1, s = {
        elements_selector: ".lazy",
        container: t || e ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, n = (e)=>Object.assign({}, s, e), l = function(e, t) {
        let a;
        const s = "LazyLoad::Initialized", n = new e(t);
        try {
            a = new CustomEvent(s, {
                detail: {
                    instance: n
                }
            });
        } catch (e) {
            a = document.createEvent("CustomEvent"), a.initCustomEvent(s, !1, !1, {
                instance: n
            });
        }
        window.dispatchEvent(a);
    }, o = "src", r = "srcset", i = "sizes", c = "poster", d = "llOriginalAttrs", _ = "data", u = "loading", g = "loaded", b = "applied", h = "error", m = "native", p = "data-", v = "ll-status", f = (e, t)=>e.getAttribute(p + t), E = (e)=>f(e, v), I = (e, t)=>((e, t, a)=>{
            const s = p + t;
            null !== a ? e.setAttribute(s, a) : e.removeAttribute(s);
        })(e, v, t), k = (e)=>I(e, null), A = (e)=>null === E(e), L = (e)=>E(e) === m, y = [
        u,
        g,
        b,
        h
    ], w = (e, t, a, s)=>{
        e && "function" == typeof e && (void 0 === s ? void 0 === a ? e(t) : e(t, a) : e(t, a, s));
    }, C = (t, a)=>{
        e && "" !== a && t.classList.add(a);
    }, O = (t, a)=>{
        e && "" !== a && t.classList.remove(a);
    }, x = (e)=>e.llTempImage, M = (e, t)=>{
        if (!t) return;
        const a = t._observer;
        a && a.unobserve(e);
    }, z = (e, t)=>{
        e && (e.loadingCount += t);
    }, N = (e, t)=>{
        e && (e.toLoadCount = t);
    }, R = (e)=>{
        let t = [];
        for(let a, s = 0; a = e.children[s]; s += 1)"SOURCE" === a.tagName && t.push(a);
        return t;
    }, T = (e, t)=>{
        const a = e.parentNode;
        a && "PICTURE" === a.tagName && R(a).forEach(t);
    }, G = (e, t)=>{
        R(e).forEach(t);
    }, D = [
        o
    ], H = [
        o,
        c
    ], V = [
        o,
        r,
        i
    ], F = [
        _
    ], B = (e)=>!!e[d], J = (e)=>e[d], S = (e)=>delete e[d], j = (e, t)=>{
        if (B(e)) return;
        const a = {};
        t.forEach((t)=>{
            a[t] = e.getAttribute(t);
        }), e[d] = a;
    }, P = (e, t)=>{
        if (!B(e)) return;
        const a = J(e);
        t.forEach((t)=>{
            ((e, t, a)=>{
                a ? e.setAttribute(t, a) : e.removeAttribute(t);
            })(e, t, a[t]);
        });
    }, U = (e, t, a)=>{
        C(e, t.class_applied), I(e, b), a && (t.unobserve_completed && M(e, t), w(t.callback_applied, e, a));
    }, $ = (e, t, a)=>{
        C(e, t.class_loading), I(e, u), a && (z(a, 1), w(t.callback_loading, e, a));
    }, q = (e, t, a)=>{
        a && e.setAttribute(t, a);
    }, K = (e, t)=>{
        q(e, i, f(e, t.data_sizes)), q(e, r, f(e, t.data_srcset)), q(e, o, f(e, t.data_src));
    }, Q = {
        IMG: (e, t)=>{
            T(e, (e)=>{
                j(e, V), K(e, t);
            }), j(e, V), K(e, t);
        },
        IFRAME: (e, t)=>{
            j(e, D), q(e, o, f(e, t.data_src));
        },
        VIDEO: (e, t)=>{
            G(e, (e)=>{
                j(e, D), q(e, o, f(e, t.data_src));
            }), j(e, H), q(e, c, f(e, t.data_poster)), q(e, o, f(e, t.data_src)), e.load();
        },
        OBJECT: (e, t)=>{
            j(e, F), q(e, _, f(e, t.data_src));
        }
    }, W = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], X = (e, t)=>{
        !t || ((e)=>e.loadingCount > 0)(t) || ((e)=>e.toLoadCount > 0)(t) || w(e.callback_finish, t);
    }, Y = (e, t, a)=>{
        e.addEventListener(t, a), e.llEvLisnrs[t] = a;
    }, Z = (e, t, a)=>{
        e.removeEventListener(t, a);
    }, ee = (e)=>!!e.llEvLisnrs, te = (e)=>{
        if (!ee(e)) return;
        const t = e.llEvLisnrs;
        for(let a in t){
            const s = t[a];
            Z(e, a, s);
        }
        delete e.llEvLisnrs;
    }, ae = (e, t, a)=>{
        ((e)=>{
            delete e.llTempImage;
        })(e), z(a, -1), ((e)=>{
            e && (e.toLoadCount -= 1);
        })(a), O(e, t.class_loading), t.unobserve_completed && M(e, a);
    }, se = (e, t, a)=>{
        const s = x(e) || e;
        ee(s) || ((e, t, a)=>{
            ee(e) || (e.llEvLisnrs = {});
            const s = "VIDEO" === e.tagName ? "loadeddata" : "load";
            Y(e, s, t), Y(e, "error", a);
        })(s, (n)=>{
            ((e, t, a, s)=>{
                const n = L(t);
                ae(t, a, s), C(t, a.class_loaded), I(t, g), w(a.callback_loaded, t, s), n || X(a, s);
            })(0, e, t, a), te(s);
        }, (n)=>{
            ((e, t, a, s)=>{
                const n = L(t);
                ae(t, a, s), C(t, a.class_error), I(t, h), w(a.callback_error, t, s), a.restore_on_error && P(t, V), n || X(a, s);
            })(0, e, t, a), te(s);
        });
    }, ne = (e, t, s)=>{
        ((e)=>W.indexOf(e.tagName) > -1)(e) ? ((e, t, a)=>{
            se(e, t, a), ((e, t, a)=>{
                const s = Q[e.tagName];
                s && (s(e, t), $(e, t, a));
            })(e, t, a);
        })(e, t, s) : ((e, t, s)=>{
            ((e)=>{
                e.llTempImage = document.createElement("IMG");
            })(e), se(e, t, s), ((e)=>{
                B(e) || (e[d] = {
                    backgroundImage: e.style.backgroundImage
                });
            })(e), ((e, t, s)=>{
                const n = f(e, t.data_bg), l = f(e, t.data_bg_hidpi), r = a && l ? l : n;
                r && (e.style.backgroundImage = `url("${r}")`, x(e).setAttribute(o, r), $(e, t, s));
            })(e, t, s), ((e, t, s)=>{
                const n = f(e, t.data_bg_multi), l = f(e, t.data_bg_multi_hidpi), o = a && l ? l : n;
                o && (e.style.backgroundImage = o, U(e, t, s));
            })(e, t, s), ((e, t, a)=>{
                const s = f(e, t.data_bg_set);
                if (!s) return;
                let n = s.split("|").map((e)=>`image-set(${e})`);
                e.style.backgroundImage = n.join(), U(e, t, a);
            })(e, t, s);
        })(e, t, s);
    }, le = (e)=>{
        e.removeAttribute(o), e.removeAttribute(r), e.removeAttribute(i);
    }, oe = (e)=>{
        T(e, (e)=>{
            P(e, V);
        }), P(e, V);
    }, re = {
        IMG: oe,
        IFRAME: (e)=>{
            P(e, D);
        },
        VIDEO: (e)=>{
            G(e, (e)=>{
                P(e, D);
            }), P(e, H), e.load();
        },
        OBJECT: (e)=>{
            P(e, F);
        }
    }, ie = (e, t)=>{
        ((e)=>{
            const t = re[e.tagName];
            t ? t(e) : ((e)=>{
                if (!B(e)) return;
                const t = J(e);
                e.style.backgroundImage = t.backgroundImage;
            })(e);
        })(e), ((e, t)=>{
            A(e) || L(e) || (O(e, t.class_entered), O(e, t.class_exited), O(e, t.class_applied), O(e, t.class_loading), O(e, t.class_loaded), O(e, t.class_error));
        })(e, t), k(e), S(e);
    }, ce = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], de = (e)=>e.use_native && "loading" in HTMLImageElement.prototype, _e = (e, t, a)=>{
        e.forEach((e)=>((e)=>e.isIntersecting || e.intersectionRatio > 0)(e) ? ((e, t, a, s)=>{
                const n = ((e)=>y.indexOf(E(e)) >= 0)(e);
                I(e, "entered"), C(e, a.class_entered), O(e, a.class_exited), ((e, t, a)=>{
                    t.unobserve_entered && M(e, a);
                })(e, a, s), w(a.callback_enter, e, t, s), n || ne(e, a, s);
            })(e.target, e, t, a) : ((e, t, a, s)=>{
                A(e) || (C(e, a.class_exited), ((e, t, a, s)=>{
                    a.cancel_on_exit && ((e)=>E(e) === u)(e) && "IMG" === e.tagName && (te(e), ((e)=>{
                        T(e, (e)=>{
                            le(e);
                        }), le(e);
                    })(e), oe(e), O(e, a.class_loading), z(s, -1), k(e), w(a.callback_cancel, e, t, s));
                })(e, t, a, s), w(a.callback_exit, e, t, s));
            })(e.target, e, t, a));
    }, ue = (e)=>Array.prototype.slice.call(e), ge = (e)=>e.container.querySelectorAll(e.elements_selector), be = (e)=>((e)=>E(e) === h)(e), he = (e, t)=>((e)=>ue(e).filter(A))(e || ge(t)), me = function(t, a) {
        const s = n(t);
        this._settings = s, this.loadingCount = 0, ((e, t)=>{
            de(e) || (t._observer = new IntersectionObserver((a)=>{
                _e(a, e, t);
            }, ((e)=>({
                    root: e.container === document ? null : e.container,
                    rootMargin: e.thresholds || e.threshold + "px"
                }))(e)));
        })(s, this), ((t, a)=>{
            e && (a._onlineHandler = ()=>{
                ((e, t)=>{
                    var a;
                    (a = ge(e), ue(a).filter(be)).forEach((t)=>{
                        O(t, e.class_error), k(t);
                    }), t.update();
                })(t, a);
            }, window.addEventListener("online", a._onlineHandler));
        })(s, this), this.update(a);
    };
    return me.prototype = {
        update: function(e) {
            const a = this._settings, s = he(e, a);
            var n, l;
            N(this, s.length), t ? this.loadAll(s) : de(a) ? ((e, t, a)=>{
                e.forEach((e)=>{
                    -1 !== ce.indexOf(e.tagName) && ((e, t, a)=>{
                        e.setAttribute("loading", "lazy"), se(e, t, a), ((e, t)=>{
                            const a = Q[e.tagName];
                            a && a(e, t);
                        })(e, t), I(e, m);
                    })(e, t, a);
                }), N(a, 0);
            })(s, a, this) : (l = s, ((e)=>{
                e.disconnect();
            })(n = this._observer), ((e, t)=>{
                t.forEach((t)=>{
                    e.observe(t);
                });
            })(n, l));
        },
        destroy: function() {
            this._observer && this._observer.disconnect(), e && window.removeEventListener("online", this._onlineHandler), ge(this._settings).forEach((e)=>{
                S(e);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function(e) {
            const t = this._settings;
            he(e, t).forEach((e)=>{
                M(e, this), ne(e, t, this);
            });
        },
        restoreAll: function() {
            const e = this._settings;
            ge(e).forEach((t)=>{
                ie(t, e);
            });
        }
    }, me.load = (e, t)=>{
        const a = n(t);
        ne(e, a);
    }, me.resetStatus = (e)=>{
        k(e);
    }, e && ((e, t)=>{
        if (t) {
            if (t.length) for(let a, s = 0; a = t[s]; s += 1)l(e, a);
            else l(e, t);
        }
    })(me, window.lazyLoadOptions), me;
}();

//# sourceMappingURL=plentyandco.51397266.js.map
